"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_1 = __importStar(require("react"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
// import { PopRechargedInvoice } from 'containers/Recharges/types';
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var ClientAgreementInvoiceDropdown_1 = __importDefault(require("../StripeClientAgreement/Invoice/ClientAgreementInvoiceDropdown"));
var InvoiceActionBar_1 = __importDefault(require("./InvoiceActionBar"));
var InvoiceTotal_1 = __importDefault(require("./InvoiceTotal"));
var tableConf_1 = require("./tableConf");
var InvoiceDetails = function (_a) {
    var _b;
    var item = _a.item, _c = _a.tableConf, tableConf = _c === void 0 ? tableConf_1.invoiceDetailsTableConf : _c, tableSize = _a.tableSize, placement = _a.placement;
    var showActionBar = placement === 'listPage';
    var _d = __read(react_1.default.useState(placement === 'listPage'), 2), showFirmView = _d[0], setShowFirmView = _d[1];
    var subTotal = (0, sumBy_1.default)(item.lineItems, 'amount');
    var taxTotal = (0, sumBy_1.default)(item.lineItems, 'taxAmount');
    var total = subTotal + taxTotal;
    var Header = (0, react_1.useMemo)(function () { return (0, HeaderMaker_1.default)(tableConf); }, [tableConf]);
    var Row = (0, react_1.useMemo)(function () { return (0, RowMaker_1.default)(tableConf); }, [tableConf]);
    return ((0, jsx_runtime_1.jsxs)(AccordionDetails_1.default, { children: [showActionBar && 'id' in item && 'companyId' in item && ((0, jsx_runtime_1.jsx)(InvoiceActionBar_1.default, { item: item, showFirmView: showFirmView, setShowFirmView: setShowFirmView })), placement === 'clientAgreement' && (0, jsx_runtime_1.jsx)(ClientAgreementInvoiceDropdown_1.default, { item: item }), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ sizing: tableSize !== null && tableSize !== void 0 ? tableSize : 'dense', mr: -2 }, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: (_b = (showFirmView ? item.lineItems : (0, end2end_1.getLineItems)(item))) === null || _b === void 0 ? void 0 : _b.map(function (lineItem, idx) {
                            var _a;
                            return ((0, jsx_runtime_1.jsx)(Row, { item: __assign({ id: (_a = lineItem.rechargeId) !== null && _a !== void 0 ? _a : "".concat(lineItem.type).concat(idx) }, lineItem) }, lineItem.rechargeId));
                        }) })] })), (0, jsx_runtime_1.jsx)(Box_1.default, { borderTop: 1, borderColor: "grey.300", mb: 0.5, width: 1, mt: 1 }), (0, jsx_runtime_1.jsx)(InvoiceTotal_1.default, { subtotal: subTotal, taxTotal: taxTotal, taxName: item.taxName, total: total, currency: item.currency, compactView: tableSize === 'compact' })] }));
};
exports.default = InvoiceDetails;
